import { useEffect, useState } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import axios, { API } from "@/lib/api";

export default function TestimonialsSection() {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    axios.get(`${API}/public/testimonials`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const t = items[index % items.length];

  return (
    <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] py-20" data-testid="testimonials-section">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <span className="text-sm font-semibold uppercase tracking-wide text-white/70">Testimoni Jamaah</span>
        <h2 className="mt-3 font-heading text-3xl font-bold text-white sm:text-4xl">Apa Kata Jamaah Kami</h2>

        <div className="mt-10 rounded-3xl bg-white/10 p-8 backdrop-blur-sm sm:p-12" data-testid="testimonial-active-card">
          <Quote className="mx-auto h-8 w-8 text-white/40" />
          <p className="mt-4 text-lg leading-relaxed text-white sm:text-xl">&ldquo;{t.content}&rdquo;</p>
          <div className="mt-6 flex items-center justify-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className={`h-4 w-4 ${i < t.rating ? "fill-amber-400 text-amber-400" : "text-white/30"}`} />
            ))}
          </div>
          <div className="mt-4 flex items-center justify-center gap-3">
            {t.photo_url && <img src={t.photo_url} alt={t.name} className="h-11 w-11 rounded-full object-cover" />}
            <div className="text-left">
              <p className="font-medium text-white">{t.name}</p>
              <p className="text-xs text-white/60">{t.city} &middot; {t.program}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center gap-3">
          <button data-testid="testimonial-prev-button" onClick={() => setIndex((i) => (i - 1 + items.length) % items.length)} className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <div className="flex gap-1.5">
            {items.map((_, i) => (
              <button key={i} data-testid={`testimonial-dot-${i}`} onClick={() => setIndex(i)} className={`h-1.5 w-6 rounded-full transition-colors ${i === index % items.length ? "bg-white" : "bg-white/30"}`} />
            ))}
          </div>
          <button data-testid="testimonial-next-button" onClick={() => setIndex((i) => (i + 1) % items.length)} className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
}
